module.exports = __webpack_public_path__ + "img/AvatarDr.fe713e64.png";